import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { Hyperlink } from '../../../objects';

@Injectable()
export class CalendarItemHyperlinkService {
 
  constructor(private apiSvc: ApiService) { }
    
  public save(link: Hyperlink, calendarItemId: string): Promise<Hyperlink> {
 
    console.log("SAVING CALENDAR ITEM HYPERLINK", link, calendarItemId);

    var model = {
      Url: link,
      CalendarItemId: calendarItemId
    };

    const p = new Promise<Hyperlink>((resolve, reject) => {

      this.apiSvc.post("api/calendaritem/url/save", model).subscribe(
        (data: Hyperlink) => {
            resolve(data);
        },
        (err) => {
          console.log("error", err); 
          reject(err);
        }
      );

    });

  return p;
  }

  public delete(id: number): Promise<void> {

    const p = new Promise<void>((resolve, reject) => {

      this.apiSvc.post("api/calendaritem/url/delete", {Id: id}).subscribe(
        (data: any) => {
            resolve();
        },
        (err) => {
          console.log("error", err); 
        }
      );

    });

  return p;
  }
}
 
 